// Striano NCC · Service Worker registration + "update available" prompt
import { toast } from "sonner";

const SW_URL = "/service-worker.js";

export function registerStrianoSW() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;
  // Solo in produzione (o se preview URL non è localhost). Evitiamo di cachare in dev locale.
  const isLocal = ["localhost", "127.0.0.1"].includes(window.location.hostname);
  if (isLocal && process.env.NODE_ENV !== "production") return;

  window.addEventListener("load", async () => {
    try {
      const reg = await navigator.serviceWorker.register(SW_URL, { scope: "/" });

      // Gestione nuova versione disponibile
      reg.addEventListener("updatefound", () => {
        const sw = reg.installing;
        if (!sw) return;
        sw.addEventListener("statechange", () => {
          if (sw.state === "installed" && navigator.serviceWorker.controller) {
            // Aggiornamento disponibile: proponi di attivarlo
            try {
              toast.message("Nuova versione disponibile", {
                description: "Ricarica per usare l'ultima versione di Striano NCC.",
                duration: 20000,
                action: {
                  label: "Aggiorna ora",
                  onClick: () => {
                    sw.postMessage({ type: "SKIP_WAITING" });
                  },
                },
              });
            } catch {}
          }
        });
      });

      // Quando il nuovo SW prende il controllo, ricarica
      let refreshing = false;
      navigator.serviceWorker.addEventListener("controllerchange", () => {
        if (refreshing) return;
        refreshing = true;
        window.location.reload();
      });

      // Check periodico aggiornamenti (ogni 30 min)
      setInterval(() => { try { reg.update(); } catch {} }, 30 * 60 * 1000);
    } catch (e) {
      // Silenzioso: la PWA non è un blocker
      // eslint-disable-next-line no-console
      console.warn("[SW] registration failed:", e);
    }
  });
}
